import moment from 'moment';
import React, { useEffect, useState } from 'react';
function EventMainList(props) {
  const popupBaseUrl = 'https://programs.sbs.co.kr'; // 버튼 링크가 팝업인 경우 에만 붙임

  const bottom = props.data; // event 에서 통으로 받은 json 중 bottom 데이터만 받아서 처리
  const convertWinDate = (data) => {
    // 2021-06-01T00:00:00.000Z 데이터 형식
    if (data.length > 9) {
      const [dateString] = data.split('T');
      const splitedDateString = dateString.split('-');

      return splitedDateString.join('.');
    } else {
      //console.log('getFormatDate 값은 10자리 이상이어야 한다.:>> ', data);
      return '';
    }
  };

  // TODO childmild : hover click 발생 하면 호버가 확대된채로  화면 이동하는데 그부분 수정해야함(모바일은 호버가 없으므로 피씨만 작업할것)
  // 1. click 이벤트시 click 함수 만들어 이동시키고 호버 부분 비활성화 액션 수정하기
  // 2. hover 시 텍스트 깜빡임 증상 image 부분 css hover after 부분 확인해보고 수정해보기
  // ex css 부분) body:after{
  //                display:none;
  //                content: url(path/to/image-hovered.jpg) url(path/to/another-image-hovered.jpg);  보면 로직으로 처리해야할듯
  //              }

  /**
   *
   * 넘겨 받은 데이터 유형(bottom json 부분)
   *
   */
  // title              타이틀
  // evt_date_txt       이벤트 날짜 (자유 입력)
  // evt_date_beg       이벤트 시작일 "2021-09-08T22:40:00.000Z"
  // evt_date_end       이벤트 종료일 "2021-09-08T22:40:00.000Z"
  // win_open_yn        Y or N 당첨 발표 공개 여부 (기간  체크)  win_date
  // win_popup_btn_yn   Y or N or null(null 일때 당첨 안띄움) 당첨 발표 공개 여부(팝업버튼 체크)
  // win_date           당첨 발표일   "2021-09-08T22:40:00.000Z"
  // win_date_txt       당첨 발표일 (자유 입력)
  // win_pub_url        당첨 발표 URL
  // pc_view_yn         PC 노출 여부 Y or N
  // m_view_yn          모바일 노출 여부 Y or N

  // 여기부터는 Top와 동일
  // img_url            PC 이미지 url
  // m_img_url          모바일 이미지 url
  // link_url           PC 링크 url
  // m_link_url         모바일 링크 url
  // link_new_yn        새창유무
  // img_alt            PC 이미지 alt
  // m_img_alt          모바일이미지 alt

  // TODO 없는 내용 파라미터 요청해야하는 부분 api
  // event_num      이벤트 번호 기획엔 없고 퍼블엔 있음  없는게 맞을듯.........
  // event_type     당첨발표 여부 파라미터  (상시: always, 기간: ing, 발표 : announce, 종료 : end, 종료(당첨발표 있음) : endan)
  // event_date_cnt 이벤트 남은기간 카운트  //d_day

  /**
   *
   * 기능 정의
   *
   */
  //  전체 이벤트 영역
  //  API 요소 : 타이틀, 시작일, 종료일, 썸네일 URL, 링크 URL, 당첨 발표일, 당첨발표 공개여부, 당첨발표 URL, 노출여부(관리자), 노출여부(메뉴)
  //  노출 옵션
  //  관리자에서 이벤트 노출 선택
  //  프로그램 템플릿인 경우 메뉴 노출여부
  //  이벤트 기간 만료 후 30일 이내

  //   1. 이벤트 종료 전
  //   노출 요소 : 썸네일, 타이틀, 기간
  //   링크 클릭 : 썸네일, 타이틀, D- 00일 버튼
  //   애니메이션 : 썸네일, 타이틀에 마우스 오버 시 썸네일 확대

  //   2. 상시 이벤트
  //   노출 요소 : 썸네일, 타이틀, 기간, 진행중 버튼
  //   링크 클릭 : 썸네일, 타이틀, D- 00일 버튼
  //   애니메이션 : 썸네일, 타이틀에 마우스 오버 시 썸네일 확대

  //   3. 이벤트 종료, 당첨자 발표일 없음
  //   노출 요소 : 썸네일, 타이틀, 기간, 종료버튼
  //   링크 클릭 : 썸네일, 타이틀, D- 00일 버튼
  //   애니메이션 : 썸네일, 타이틀에 마우스 오버 시 썸네일 확대

  //   4. 이벤트 종료, 당첨자 발표 전
  //   노출 요소 : 썸네일, 타이틀, 당첨발표일, 종료버튼
  //   링크 클릭 : 썸네일, 타이틀, D- 00일 버튼
  //   애니메이션 : 썸네일, 타이틀에 마우스 오버 시 썸네일 확대

  //   5. 이벤트 종료, 당첨자 발표 후
  //   노출 요소 : 썸네일, 타이틀, 당첨발표일,당첨버튼(당첨결과 링크)
  //   당첨 버튼 클릭 시 당첨자 발표 팝업 호출 (프로그램 템플릿 당첨자 발표와 동일)
  //     - 프로그램 템플릿이 아닌 경우 신규관리자에서 별도 생성 고려

  // event_type     당첨발표 여부 파라미터  (상시: always, 기간: ing, 발표 : announce, 종료 : end, 종료(당첨발표 있음) : endan)

  // 주말 작업하면서 바뀐 부분 정리
  // 상시 이벤트이고 결과발표일 값이 있으면 종료일을 N으로
  // "d_day": -28,
  // "is_evt_always": "N", //상시 이벤트
  // "is_evt_end": "N"     //상시 아니고 종료 아닌

  // TODO ..................... 10.07 추가사항
  // win_popup_btn_yn   Y or N or null(null 일때 당첨 안띄움) 당첨 발표 공개 여부(팝업버튼 체크)
  // win_popup_btn_yn 이 Y 또는 N일때   https://programs.sbs.co.kr 삽입

  return (

    <div className='contents_area_eventlist'>
      <div className="contents_side_ad sideAd_right">
        <div className="side_ad_inner">
          <iframe title='배너광고' display='block' src='/html/pc/event_right.htm' width='120px' height='600px' scrolling='no' frameBorder='0' align='middle' marginWidth='0' marginHeight='0' />
        </div>
      </div>
      <div className='event_list_w'>
        <ul className='event_list_inner'>

          {bottom != null
            ? bottom.map((item, index) => {
              if (item.pc_view_yn === 'Y') {
                if (item.link_url) {
                  const temp = new URL(item.link_url);
                  temp.searchParams.set('div', 'event_bottom');
                  item.link_url = temp.toString();
                }
                return (
                  <li key={index} className='event_list_cont'>
                    <div className='module_box_w_type9'>
                      <a href={item.link_url} className='mb_link' target={(item.link_new_yn === 'Y' ? '_blank' : '')}>
                        <div className='mb_image_w'>
                          <div className='mb_image_inner'>
                            <img src={item.img_url} className='mb_image' alt={item.img_alt || item.title} />
                          </div>
                        </div>
                        <div className='mb_info_w'>
                          <span className='mbif_title'><span className='mbif_ep' />{item.title}</span>
                          <span className='mbif_date'>
                            {
                              (item.is_evt_always === 'Y') ? item.evt_date_txt
                                : (item.win_open_yn === 'Y' && item.is_evt_end === 'Y') ? '당첨 발표 : ' + (convertWinDate(item.win_date) || item.win_date)// moment(item.win_date).format('YYYY.MM.DD')
                                  : (item.win_open_yn === 'Y' && item.is_evt_end === 'N') ? moment(item.evt_date_beg).format('YYYY.MM.DD') + ' ~ ' + moment(item.evt_date_end).format('YYYY.MM.DD')
                                    : (item.event_type === 'end') ? moment(item.evt_date_end).format('YYYY.MM.DD')
                                      : (item.evt_date_end != '') ? moment(item.evt_date_beg).format('YYYY.MM.DD') + ' ~ ' + moment(item.evt_date_end).format('YYYY.MM.DD')
                                        : ''
                            }
                          </span>
                        </div>
                      </a>
                      {
                        (item.is_evt_always === 'Y') ? <div className='mb_dday_ing'>진행중</div>
                          : (item.win_popup_btn_yn === 'Y' && item.win_pub_url !== null)
                            ? <a onClick={() => window.open(popupBaseUrl + item.win_pub_url, item.title, 'width = 400, height = 450, top = 100, left = 200, location = no')} target='_blank' className='mb_announce_link' title='당첨자발표 팝업 열림'>
                              <div className='mb_dday_announce'>
                                <span className='mbd_cont_inner'>
                                  당첨<br />발표
                                  <i className='mbd_cont_arrow'><svg xmlns='http://www.w3.org/2000/svg' width='6' height='10' viewBox='0 0 6 10'><path d='M108.3,366.415a.417.417,0,0,0,.281-.106l5.324-4.894-5.324-4.893a.422.422,0,0,0-.56,0,.344.344,0,0,0,0,.515l4.763,4.378-4.763,4.379a.344.344,0,0,0,0,.515A.415.415,0,0,0,108.3,366.415Z' transform='translate(-107.901 -356.415)' /></svg></i>
                                </span>
                              </div>
                            </a>
                            : (item.is_evt_end === 'N')
                            ? <div className='mb_dday_number'>D{item.d_day !== 0 ? item.d_day : '-day'}</div>
                            : (item.is_evt_end === 'Y')
                              ? <div className='mb_dday_end'>종료</div>
                              : ''
                      }
                    </div>
                  </li>
                );
              } else {
                return (<React.Fragment key={index} />);
              }
            })
            : (<div />)}

        </ul>
      </div>
    </div>
  );
}

export default EventMainList;
